import React from 'react';
import PropTypes from 'prop-types';
import useRedirection from '../../../hooks/multiLocality/useRedirection';

const DisplayText = (props) => {
    const redirect = useRedirection({
        searches: [{
            suggestion: props.suggestion,
            suggestionType: props.suggestionType,
        }],
        statusType: 'all',
        isHistoric: false,
        entryPoint: props.entryPoint,
    });
    return (
        <a onClick={redirect}>
            {props.displayText}
        </a>
    );
}

DisplayText.propTypes = {
    suggestion: PropTypes.string,
    suggestionType: PropTypes.string,
    entryPoint: PropTypes.string,
    displayText: PropTypes.string,
    dispatch: PropTypes.func,
};

export default DisplayText;